import { ObjectDb } from './object.db';
import { DiagnosisGridItemObject } from '@it2go/types';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DiagnosisDb extends ObjectDb<DiagnosisGridItemObject> {

    public tableName: string = 'diagnosis';

    protected override columnMap = {
        code: 'code',
    };

    protected override checkField = 'updatedAt';

    protected override refreshOnUserChange = false;

    protected override indices = ['code'];

    protected gqlMethod = 'getDiagnoses';

    protected override pageSize: number = 1_000;

    protected syncFragment = `
        updatedAt
        code
        name
        parentName
        selectable
    `;

}
